'use strict';

/*
  PungleService
  Handles communication with FE Pungle API.
  Parameters:
    presenter [APIPresenter] (required):
*/

function PungleService(presenter, env) {
  this._presenter = presenter;
  this._env = env || 'staging';
  this._serverErrors = ['account_not_verified', 'cvv_failure', 'account_marked_as_lost_or_stolen', 'suspected_fraud', 'invalid_financial_account_details'];
  this._inlineErrors = ['invalid_name', 'invalid_card_number', 'invalid_card_brand', 'invalid_expiry_month', 'invalid_expiry_year', 'invalid_cvv', 'invalid_address', 'invalid_address_city', 'invalid_address_state', 'invalid_address_country', 'invalid_postal_code', 'invalid_financial_account_details'];

  this._init = function () {
    this.pungleJSPromise = this._loadPungleJSLib();
  };

  this.createToken = function (publicAPIKey, vdCard, successCallback, failureCallback) {
    if (this.pungleJSPromise) {
      $.when(this.pungleJSPromise).then(this._sendRequest.bind(this, publicAPIKey, vdCard, successCallback, failureCallback));
    } else {
      this._sendRequest(publicAPIKey, vdCard, successCallback, failureCallback);
    }
  };

  this._sendRequest = function (publicAPIKey, vdCard, successCallback, failureCallback) {
    var _this = this;

    if (!this._pungle) {
      this._pungle = Pungle(publicAPIKey);
    }
    this._pungle.createToken(vdCard).then(function (res) {
      if (res.error) {
        if (_this._serverErrors.indexOf(res.error.code) > -1) {
          res.error.isPungleError = true;
        } else if (_this._inlineErrors.indexOf(res.error.code) > -1) {
          res.error.isInlineError = true;
        }
        if (typeof failureCallback === 'function') failureCallback(res.error);
      } else {
        // Business requires that if it's a business card, we want to capture it and display an error screen.
        if (res.data && res.data.card_holder_type === 'business') {
          if (typeof failureCallback === 'function') failureCallback({
            code: 'invalid_card_holder_type',
            message: 'This is a business card'
          });
        } else if (typeof successCallback === 'function') {
          successCallback(res.data);
        }
      }
    });
  };

  this._loadPungleJSLib = function () {
    if (typeof Pungle === 'undefined') {
      this._env = this._env || 'staging';
      return $.ajax({
        url: 'https://' + (this._env === 'staging' ? 'js.staging.pungle.co' : 'js.pungle.io') + '/resources/v1.1.0/index.js',
        dataType: 'script',
        cache: true
      });
    }
  };

  this._init();
}